<template>
  <el-dialog :title="scheduleVis ? $t('lang.addSchedule') : $t('lang.addFormat')" :visible.sync="visible" width="500px" :before-close="handleClose">
    <el-form :model="form" status-icon :rules="rules" ref="form" class="create_scte">
      <el-form-item :label="$t('lang.dateStyle')" prop="scheduleType" v-if="scheduleVis">
        <el-select v-model="form.scheduleType" :placeholder="$t('lang.choice')">
          <el-option label="weekly" value="1"></el-option>
          <el-option label="day" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('lang.name')" prop="nickName">
        <el-input type="text" v-model="form.nickName" autocomplete="off" maxlength="32"></el-input>
      </el-form-item>

      <div class="btn_box">
        <el-form-item>
          <!-- <el-button type="primary" @click="createScle()">{{$t('lang.add')}}</el-button> -->
          <el-button @click="handleClose">{{ $t("lang.cancel") }}</el-button>
          <el-button type="primary" @click="save()">{{ $t("lang.next") }}
          </el-button>
        </el-form-item>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import Bus from '@/assets/js/vueBus.js'
import toTips from '@/assets/js/toTipsObj'
// const googleKey = 'playout';
export default {
  props: {
    scheduleVis: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      visible: false,
      title: '',
      spliceTypeValue: '0',
      options: [
        {
          value: '0',
          label: 'Start Normal'
        },
        {
          value: '1',
          label: 'Start Immediate'
        },
        {
          value: '2',
          label: 'End Normal'
        },
        {
          value: '3',
          label: 'End Immediate'
        },
        {
          value: '4',
          label: 'Cancel'
        }
      ],
      form: {
        nickName: '',
        scheduleType: '1'
      },
      rules: {
        // return {
        nickName: [
          {
            required: true,
            message: this.$t('lang.nameEmpty'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created () {
  },
  computed: {},
  watch: {
    scheduleVis (val) {
      if (val) {
        this.visible = val
        this.form = {
          nickName: '',
          scheduleType: '1'
        }
      }
    }
  },

  methods: {
    save () {
      if (!this.form.nickName.trim()) {
        this.$message.error(this.$t('lang.nameEmpty'))
        return
      }
      const params = {
        name: this.form.nickName,
        type: '1',
        scheduleType: this.form.scheduleType
      }
      this.axios.post('/gatewayPlayoutUrl/tvu-playout/template/add', params).then((res) => {
        if (res.status == 200) {
          if (res.data.errorCode == '0x0') {
            const { id } = res.data.result
            this.$emit('visible', {
              status: false,
              name: 'scheduleVis',
              add: true,
              templateId: id,
              scheduleType: this.form.scheduleType
            })
            Bus.$emit('nextAdd', true)
            this.visible = false
          } else {
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }
      }).catch()
    },
    // 取消创建
    cancel () {
      this.handleClose()
    },

    // 关闭弹窗
    handleClose (manualClose) {
      this.$emit('visible', { status: false, name: 'scheduleVis' })
      this.visible = false
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-input__inner,
.el-textarea__inner,
.el-input__inner:focus:focus {
  border: none !important;
}
/deep/ .el-form-item__content .el-input__suffix {
  display: none;
}
/deep/ .create_booking_box .el-form-item {
  margin-bottom: 16px;
}
/deep/
  .el-dialog
  .el-dialog__header
  .el-dialog__headerbtn
  .el-icon-close:before {
  content: '\E602';
  color: #fff;
}
/deep/ .el-dialog {
  padding: 29px 20px 40px !important;
  .el-dialog__headerbtn .el-dialog__close .el-icon-close:before {
    content: '\E602';
    color: #fff;
  }
}
/deep/
  .el-form-item.is-required:not(.is-no-asterisk)
  > .el-form-item__label:before {
  color: #fff;
  margin-right: 0;
}
.create_booking_box {
  /deep/ .el-input__icon.el-icon-time {
    display: none;
  }
}
/deep/ .el-input__suffix .el-icon-arrow-up:before {
  content: '\E60C';
}
/deep/ .el-input__inner {
  background: #444 !important;
}
/deep/ .el-dialog {
  padding: 10px 30px;
  .el-dialog__header {
    height: auto;
    line-height: normal;
    padding-bottom: 19px;
    .el-dialog__title {
      font-size: 20px;
      font-weight: 700;
    }
    .el-dialog__headerbtn {
      font-size: 20px;
    }
  }
  .el-dialog__header .el-dialog__headerbtn .el-icon-close,
  .el-dialog__header .el-dialog__headerbtn .el-icon-close:hover {
    transform: rotate(-45deg);
    font-size: 27px;
    margin-top: 26px;
  }
}
/deep/ .el-date-editor.el-input {
  width: 150px;
  float: left;
}
/deep/ .el-input--prefix .el-input__inner {
  padding-left: 5px;
  padding-right: 5px;
}
/deep/ .delay_bit {
  .el-input {
    width: 150px;
  }
  > .el-form-item > .el-form-item__content {
    margin-left: 103px !important;
  }
}
.btn_box {
  /deep/ .el-form-item__content {
    width: 90%;
    margin-left: 10% !important;
  }
  /deep/ .el-form-item {
    margin-bottom: 0;
  }
  /deep/ .el-button {
    width: 120px;
    font-size: 12px;
  }
  /deep/ .el-button--primary {
    margin-right: 41px;
  }
}
/deep/ .el-select {
  display: block;
}
/deep/
  .el-form-item.is-required:not(.is-no-asterisk)
  > .el-form-item__label:before {
  content: '';
}
/deep/ .splice_type_sel .el-input__suffix {
  display: block;
  margin-top: 40px;
  height: 46px;
  z-index: 1001;
}
</style>
